import { EnhancedCampaign } from '~/components/casino-shared/types';

const useBannerHelpers = (
	{
		headerText,
		descriptionText,
		ctaText,
		foregroundImage1,
		foregroundImage2,
		textPosition,
		mobileLayoutType
	}: EnhancedCampaign,
	index: number
) => {
	let columnItemsCount = 0;

	const isAnyTextVisible = !!headerText || !!descriptionText || !!ctaText;

	const isAllImagesEnabled = !!foregroundImage1 && !!foregroundImage2;

	if (isAnyTextVisible) {
		columnItemsCount += 1;
	}

	if (foregroundImage1) {
		columnItemsCount += 1;
	}

	if (isAllImagesEnabled) {
		columnItemsCount += 1;
	}

	const isTextCentered = textPosition === 'CENTER';

	const isSingleItem = columnItemsCount <= 1;

	const isHorizontalOnMobile = mobileLayoutType !== 'VERTICAL';

	const shouldLazyLoad = index > 0;

	return {
		columnItemsCount,
		isAnyTextVisible,
		isAllImagesEnabled,
		isTextCentered,
		isSingleItem,
		isHorizontalOnMobile,
		shouldLazyLoad
	};
};

export type BannerHelpers = ReturnType<typeof useBannerHelpers>;

export default useBannerHelpers;
